
import React from 'react';
import { Form, Input, Button, FormInstance } from 'antd';
import { useIntl } from 'react-intl';

export type HotelProfileFormValues = {
  code: string;
  name: string;
  active: boolean;
};

interface HotelProfileFormProps {
  form: FormInstance;
  onFinish: (values: HotelProfileFormValues) => void | Promise<void>;
  initialValues?: Partial<HotelProfileFormValues>;
  isEdit?: boolean;
  submitLoading?: boolean;
}

const HotelProfileForm: React.FC<HotelProfileFormProps> = ({
  form,
  onFinish,
  initialValues,
  isEdit = false,
  submitLoading = false,
}) => {
  const intl = useIntl();

  const noSpacesValidator = (_: any, value: string) => {
    if (value && value.includes(' ')) {
      return Promise.reject(new Error('Hotel code cannot contain spaces.'));
    }
    return Promise.resolve();
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={initialValues}
    >
      <Form.Item
        name="code"
        label={intl.formatMessage({ id: 'admin.hotel_profile.code', defaultMessage: 'Hotel Code' })}
        rules={[
          { 
            required: true, 
            message: 'Please input the hotel code!'
          },
          { validator: noSpacesValidator }
        ]}
      >
        <Input disabled={isEdit} />
      </Form.Item>
      <Form.Item
        name="name"
        label={intl.formatMessage({ id: 'admin.hotel_profile.name', defaultMessage: 'Hotel Name' })}
        rules={[{ required: true, message: 'Please input the hotel name!' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={submitLoading}>
          {isEdit 
            ? intl.formatMessage({ id: 'common.update', defaultMessage: 'Update' })
            : intl.formatMessage({ id: 'common.create', defaultMessage: 'Create' })}
        </Button>
      </Form.Item>
    </Form>
  );
};

export default HotelProfileForm;
